// Helper: Resize Shopify image
const getResizedImageUrl = (url) => {
  const regex = /(\.[a-zA-Z0-9]+)(\?v=\d+)?$/;
  return url.replace(regex, (match, ext, version) => {
    return `_400x${ext}${version || ''}`;
  });
};

const urlParams = new URLSearchParams(window.location.search);

const generatePaginationHtmlSearch = (totalItems, itemsPerPage, currentPage, urlParams) => {
  // Sometimes, urlparams comes encoded, in that case we decode it , check for %2F
  let decodedParams = new URLSearchParams(urlParams);

  const totalPages = Math.ceil(totalItems / itemsPerPage);
  if (totalPages <= 1) return '';

  // Helper to build URL for a given page
  const buildPageUrl = (page) => {
    const params = decodedParams;
    params.set('page', page);

    if (params.toString().startsWith('%2Fsearch%3F')) {
      return `/search?${params.toString().split('%2Fsearch%3F')[1]}`;
    }
    return `/search?${params.toString()}`;
  };

  let html = '<ul class="pagination__list list-unstyled" role="list">';

  // Previous arrow
  if (currentPage > 1) {
    html += `<li><a href="${buildPageUrl(currentPage - 1)}" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce" aria-label="Vorherige Seite"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></a></li>`;
  }

  // Page numbers logic
  const pageWindow = 2; // how many pages to show before/after current
  let startPage = Math.max(1, currentPage - pageWindow);
  let endPage = Math.min(totalPages, currentPage + pageWindow);

  if (startPage > 1) {
    html += `<li><a href="${buildPageUrl(1)}" class="pagination__item link" aria-label="Seite 1">1</a></li>`;
    if (startPage > 2) {
      html += '<li><span class="pagination__item">…</span></li>';
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    if (i === currentPage) {
      html += `<li><span class="pagination__item pagination__item--current" aria-current="page" aria-label="Seite ${i}">${i}</span></li>`;
    } else {
      html += `<li><a href="${buildPageUrl(i)}" class="pagination__item link" aria-label="Seite ${i}">${i}</a></li>`;
    }
  }

  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      html += '<li><span class="pagination__item">…</span></li>';
    }
    html += `<li><a href="${buildPageUrl(totalPages)}" class="pagination__item link" aria-label="Seite ${totalPages}">${totalPages}</a></li>`;
  }

  // Next arrow
  if (currentPage < totalPages) {
    html += `<li><a href="${buildPageUrl(currentPage + 1)}" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce" aria-label="Nächste Seite"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg></a></li>`;
  }

  html += '</ul>';
  return html;
};


// Main handler
const handleNostoApiCallSearch = async (forcedPage = 1, append = false, url, callback = null) => {
  const paginationPageSize = document.querySelector('[data-pagination-size]');
  const page = forcedPage || 1;
  const pageSize = paginationPageSize ? parseInt(paginationPageSize.getAttribute('data-pagination-size')) : 20;

  console.log("page size", pageSize)
  const start = (page - 1) * pageSize;
  const startTime = performance.now();

  const params = new URLSearchParams(url);
  let searchParams = url.startsWith('?') ? url.slice(1) : url;
  let sortByValue = null;
  let sortField = "";
  let sortOrder = "";
  let minPrice = "5";
  let maxPrice = "100";
  let customCollection = [];
  let sizes = [];
  let colors = [];
  let bassoms = [];

  // sort by logic
  if (searchParams.trim() != '' && searchParams.includes('&')) {
    let searchItems = searchParams.split('&');
    searchItems.forEach(param => {
      if (param.startsWith("sort_by=")) {
        sortByValue = param.split('=')[1];
      }
      if (param.includes("gte=")) {
        minPrice = param.split('=')[1];
      }
      if (param.includes("lte=")) {
        maxPrice = param.split('=')[1];
      }
      if (param.includes("custom.collection=")) {
        const value = param.split('=')[1].replace(/\+/g, ' ');
        customCollection.push(`["${value}"]`);
      }
      if (param.includes("custom.color_hex=")) {
        const colorMapEl = document.getElementById('color-hex-map');
        const colorMap = colorMapEl ? JSON.parse(colorMapEl.textContent) : {};
        document.querySelectorAll('input.color-facet-r').forEach(input => {
          const label = input.getAttribute('value'); // e.g. "Blanc|#FFFFFF" (translated)
          const hex = label.split('|')[1]?.toUpperCase();

          if (hex && colorMap[hex]) {
            input.setAttribute('data-raw', colorMap[hex]); // e.g. "Weiß|#FFFFFF"
          } else {
            input.setAttribute('data-raw', hex); // fallback to just hex
          }
        });
        let rawVal = param.split('=')[1]; // Still URL-encoded
        rawVal = rawVal.replace(/\+/g, ' '); // Replace + with space
        const paramVal = decodeURIComponent(rawVal); // e.g. "Blanc|#FFFFFF"
        const matchingInput = document.querySelector(`input.color-facet-r[value="${paramVal}"]`);

        if (matchingInput) {
          const raw = matchingInput.getAttribute('data-raw'); // "Weiß|#FFFFFF"
          const colorName = raw?.split('|')[0]; // "Weiß"
          if (colorName) colors.push(colorName);
        } else {
          // fallback if data-raw not found
          const fallbackColor = paramVal.split('|')[0];
          colors.push(fallbackColor);
        }
      }

      if (param.includes("option.size=")) {
        sizes.push(param.split('=')[1].replace(/\+/g, " "));
      }
      if (param.includes("custom.booty_passform=")) {
        bassoms.push(`[\"${param.split('=')[1].replace(/\+/g, " ")}\"]`);
      }
    });
  } else if (searchParams.trim() != '') {
    if (searchParams.includes("sort_by=")) {
      sortByValue = searchParams.split("=")[1];
    }
    if (searchParams.includes("custom.collection=")) {
      const value = searchParams.split('=')[1].replace(/\+/g, ' ');
      customCollection.push(`["${value}"]`);
    }
    if (searchParams.includes("custom.color_hex=")) {
      colors.push(`${searchParams.split('=')[1].split('%')[0]}`);
    }
    if (searchParams.includes("option.size=")) {
      sizes.push(searchParams.split('=')[1]);
    }
    if (searchParams.includes("custom.booty_passform=")) {
      bassoms.push(`[\"${searchParams.split('=')[1].replace(/\+/g, " ")}\"]`);
    }
  }

  if (sortByValue === "price-ascending") {
    sortField = "price";
    sortOrder = "asc";
  } else if (sortByValue === "price-descending") {
    sortField = "price";
    sortOrder = "desc";
  }

  let filters = [];
  if (customCollection.length > 0) {
    filters.push({ "field": "customFields.custom-collection", "value": customCollection });
  }
  if (colors.length > 0) {
    filters.push({ "field": "extra.color", "value": colors });
  }
  if (sizes.length > 0) {
    filters.push({ "field": "skus.customFields.size", "value": sizes });
    filters.push({ "field": "skus.availability", "value": "InStock" });
  }
  if (bassoms.length > 0) {
    filters.push({ "field": "customFields.custom-booty_passform", "value": bassoms });
  }
  if (minPrice && maxPrice) {
    filters.push({
      "field": "price",
      "range": [{ "gte": minPrice, "lte": maxPrice }]
    });
  }

  // Optional: Push search query to GA4
  if (params.has('q')) {
    const searchTermVal = params.get('q');
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'search', search_term: searchTermVal });
  }

  const XsearchParams = new URLSearchParams(window.location.search);
  const searchTerm = XsearchParams.get('q');

  try {
    const response = await new Promise((resolve, reject) => {
      nostojs(api => {
        const isSerp = window.location.pathname.includes("/search");
        api.search({
          query: searchTerm,
          products: {
            facets: ['*'],
            fields: ['productId', 'name', 'url', 'imageUrl', 'price', 'alternateImageUrls'],
            sort: sortField ? [{ field: sortField, order: sortOrder }] : [],
            filter: [{ all: filters }],
            size: pageSize,
            from: start
          }
        }, { track: 'serp', redirect: (typeof markethandle !== 'undefined' ? markethandle : '/') === "/" && isSerp ? true : false, isKeyword: true }).then(resolve).catch(reject);
      });
    });

    // ✅ Sync Shopify facets with Nosto facets
    window.nostoSideSearchResponse = response;
    if (response.products?.facets && typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.rebuildFacets === 'function') {
      FacetFiltersForm.rebuildFacets(response.products.facets);
    }

    const totalResults = response.products?.total || 0;
    const productsWrapper = document.querySelector('#product-grid');
    const productLoader = document.querySelector('.loader_element');
    const emptyText = document.querySelector('.title-wrapper__empty');
    const productCountWrapper = document.querySelectorAll('[data-products-count-text]');
    console.log({ productCountWrapper });
    const loadingBtn = document.querySelector('#loading_next .button');

    if (productsWrapper && productLoader && emptyText) {
      const products = response.products?.hits || [];
      const resultId = response.result_id;

      if (products.length > 0) {
        const firstVariantIds = products.map(p => p.skus?.[0]?.id).filter(Boolean);
        const productHandles = products.map(p => p.url).filter(Boolean);
        const useHandles = productHandles[0]?.startsWith("https://teveo.com/products");

        const requests = useHandles
          ? productHandles.map(url => {
            const path = new URL(url).pathname;
            const marketUrl = window.routes?.root_url?.replace(/\/$/, '') || '';
            return fetchProductCardHTML(`${marketUrl}${path}`, 'recommended-products__item', true);
          })
          : firstVariantIds.map(id => fetchProductCardHTMLByFirstVariant(id, 'recommended-products__item'));

        const responses = await Promise.all(requests);
        const cardsHtml = responses.join('');

        const tempWrapper = document.createElement('div');
        tempWrapper.innerHTML = cardsHtml;

        tempWrapper.querySelectorAll('.product-details__wrapper a').forEach(a => {
          try {
            const url = new URL(a.href);
            url.searchParams.set('nosto', resultId);
            a.href = url.toString();
          } catch (e) {
            console.warn('Invalid product link', a.href);
          }
        });

        tempWrapper.querySelectorAll('.recommended-products__item').forEach(el => {
          el.classList.remove('recommended-products__item');
          el.classList.add('grid__item');
        });

        const newItems = tempWrapper.querySelectorAll('.grid__item');

        if (!append) productsWrapper.innerHTML = '';
        newItems.forEach(item => productsWrapper.appendChild(item));

        // ✅ Nosto Tracking: Clicks + Add-to-Cart
        newItems.forEach((item, index) => {
          const product = products[index];
          if (!product) return;

          const productId = product.productId;
          const productUrl = product.url;

          // ✅ Track search click on product link
          const link = item.querySelector('a[href*="/products/"]');
          if (link) {
            link.addEventListener('click', () => {
              nostojs(api => {
                api.recordSearchClick('serp', { productId, url: productUrl });
              });
            });
          }

          // ✅ Track add-to-cart clicks
          const buttons = item.querySelectorAll('.sizes__wrapper--item:not([disabled]), .size-button:not([disabled])');
          buttons.forEach(button => {
            button.addEventListener('click', () => {
              const productHandle = button.dataset.productHandle || button.closest('[data-product-handle]')?.dataset.productHandle;
              const prodId = button.dataset.productId || button.closest('[data-product-id]')?.dataset.productId;
              const prodUrl = `https://teveo.com/products/${productHandle}`;
              if (prodId && prodUrl) {
                nostojs(api => {
                  api.recordSearchAddToCart('serp', { productId: prodId, url: prodUrl });
                });
              }
            });
          });
        });

        productLoader.classList.add('hidden');
        productsWrapper.classList.remove('hidden');
        emptyText.classList.add('hidden');

        // Update filter label
        const filterLabel = document.querySelector('.mobile-facets__open-label-count');
        if (filterLabel) {
          const currentURL = new URL(window.location.href);
          const ignoredParams = ['page', 'sort_by', 'q', 'options[prefix]'];
          let filterCount = 0;
          currentURL.searchParams.forEach((value, key) => {
            if (!ignoredParams.includes(key)) filterCount++;
          });
          filterLabel.textContent = filterCount > 0 ? `${filterCount}` : '';
        }

        let currentProducts = products.length;
        const productCountsText = {
          '{{total_products}}': totalResults,
          '{{current_products}}': currentProducts
        };

        if (productCountWrapper && loadingBtn) {
          currentProducts = parseInt(loadingBtn.getAttribute('data-hits') || '0') + products.length;
          if (append) {
            loadingBtn.classList.remove('loading-products');
            loadingBtn.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
          }
          loadingBtn.setAttribute('data-hits', currentProducts);
          loadingBtn.setAttribute('data-total', totalResults);


          if (currentProducts === totalResults) loadingBtn.classList.add('hidden');
        }
        if (productCountWrapper) {
          productCountWrapper.forEach(wrapper => {

            const span = wrapper.querySelector('span');
            if (span) {
              span.innerHTML = wrapper.dataset.productsCountText.replace(/{{total_products}}|{{current_products}}/gi, matched => productCountsText[matched]);
            }

            // loadingBtn.classList.remove('hidden');
            wrapper.classList.remove('hidden');
            if (typeof initButtons === 'function') initButtons();
          });
        }
      } else {
        // empty the product list too.
        if (!append) {
          productsWrapper.innerHTML = '';
        }
        productLoader.classList.add('hidden');
        emptyText.classList.remove('hidden');
        if (loadingBtn) loadingBtn.classList.add('hidden');
        productCountWrapper.forEach(wrapper => {
          wrapper.classList.add('hidden');
        });

        const linkInsideEmptyText = emptyText.querySelector('a');
        if (linkInsideEmptyText) {
          const ignoredParams = ['page', 'sort_by', 'q', 'options[prefix]'];
          const currentURL = new URL(window.location.href);
          const searchParamsCleaned = new URLSearchParams();
          currentURL.searchParams.forEach((value, key) => {
            if (ignoredParams.includes(key)) searchParamsCleaned.append(key, value);
          });
          const marketRoot = (window.routes?.root_url || '').replace(/\/$/, '');
          linkInsideEmptyText.href = `${marketRoot}/search?${searchParamsCleaned.toString()}`;
        }
      }

      const paginationElement = document.querySelector('div.pagination-wrapper > nav');
      const pCount = pageSize;
      if (paginationElement) {
        paginationElement.innerHTML = generatePaginationHtmlSearch(totalResults, pCount, page, params);
      } else if (totalResults > pCount) {
        const pWrapper = document.createElement('div');
        pWrapper.setAttribute('class', 'pagination-wrapper');
        const pElement = document.createElement('nav');
        pElement.setAttribute('class', 'pagination');
        pElement.setAttribute('role', 'navigation');
        pElement.setAttribute('aria-label', 'Pagination');
        pElement.innerHTML = generatePaginationHtmlSearch(totalResults, pCount, page, params);
        pWrapper.appendChild(pElement);
        const resultsDiv = document.querySelector('#ProductGridContainer > div.template-search__results');
        if (resultsDiv) resultsDiv.appendChild(pWrapper);
      }


      document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
      const endTime = performance.now();
      console.log(`handleNostoApiCallSearch (Search) took ${endTime - startTime} ms`);

      if (typeof callback === 'function') callback();
    }
  } catch (error) {
    console.error("Nosto Logs: ", error);
  }
};

handleNostoApiCallSearch(parseInt(urlParams.get("page") || "1", 10), false, window.location.search);